<template>
  <v-form>
    <v-card>
      <v-card-title>
        <h4 class="text-center"><v-icon>mdi-playlist-edit</v-icon> {{name}} - Zeitmodell</h4>
      </v-card-title>
      <v-card-text>
        <div>Default Zeitmodell:</div>
        <v-select
          :items="clearableTimeModels"
          item-text="name"
          item-value="id"
          v-model="timeModelId"
          placeholder="Default Zeitmodell"
          hint="Default Zeitmodell"
        />

        <h2 class="mt-4">Zeitmodelle für einen bestimmten Zeitraum:</h2>
        <v-row wrap>
          <v-col cols="7">
            <date-range ref="dateRange" @changed="onDateRangeSelected" />
          </v-col>
          <v-col cols="4">
            <v-select
              :items="timeModels"
              item-text="name"
              item-value="id"
              v-model="newTimeModelId"
              placeholder="Zeitmodell"
              hint="Zeitmodell"
            />
          </v-col>
          <v-col col="1" class="pl-2 pt-8">
            <v-btn
              @click="addTimeModel"
              color="blue ligthen-4"
              dark
              small
              bottom
              fab
              :disabled="!isNewTimeModelValid"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <div v-if="!isFromBeforeEnd" class="red--text text--lighten-1">
          * Startzeit muss vor der Endzeit liegen
        </div>
        <div v-if="newTimeModelOverlapsWithExistingModels" class="red--text text--lighten-1">
          * Es ist bereits ein Zeitmodell ausgewählt für diese Zeitspanne
        </div>
        <v-simple-table v-if="showTimeModelList">
          <thead>
            <tr>
              <th class="text-left">Zeitmodell</th>
              <th class="text-left">Von</th>
              <th class="text-left">Bis</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(t, i) in userTimeModels" :key="i">
              <td>{{getTimeModelName(t.timeModelId)}}</td>
              <td>{{utcMoment(t.start).local().format('DD.MM.YYYY HH:mm')}}</td>
              <td>{{utcMoment(t.end).local().format('DD.MM.YYYY HH:mm')}}</td>
              <td>
                <v-btn
                  icon
                  @click="removeTimeModel(i)"
                  color="red"
                  small
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="default" text @click="cancel" :loading="saving">Abbrechen</v-btn>
        <v-btn color="primary" @click="save" :disabled="!valid" :loading="saving">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>

import moment from 'moment';
import DateRange from '../common/DateRange';
import timeparkApi from '../../timeparkApi';

export default {
  name: 'UserTimeModels',
  props: {
    initialUser: {
      type: Object,
    },
  },
  components: {
    DateRange,
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    clearableTimeModels() {
      return [
        {
          id: null,
          name: ' - ',
        }
        ,
        ...this.$store.state.timeModels
      ]
    },
    timeModels() {
      return [
        ...this.$store.state.timeModels
      ]
    },
    isNewTimeModelValid() {
      if (!this.from || !this.to || !this.newTimeModelId) {
        return false;
      }

      return true;
    },
    valid() {
      return true;
    },
    newTimeModelOverlapsWithExistingModels() {
      if (!this.from || !this.to) {
        return false;
      }

      return this.userTimeModels.some((x) => {
        const s = moment.utc(x.start);
        const e = moment.utc(x.end);

        const newS = moment.utc(this.from);
        const newE = moment.utc(this.to);

        return (s.isSameOrBefore(newS) && e.isSameOrAfter(newS)) ||
          (s.isSameOrBefore(newE) && e.isSameOrAfter(newE))
      });
    },
    isFromBeforeEnd() {
      if (!this.from || !this.to) {
        return true;
      }

      return moment.utc(this.from).isBefore(moment.utc(this.to));
    },
    showTimeModelList() {
      return this.userTimeModels.length > 0;
    },
  },
  methods: {
    utcMoment(utc) {
      return moment.utc(utc);
    },
    getTimeModelName(timeModelId) {
      return this.clearableTimeModels.find(x => x.id === timeModelId).name;
    },
    onDateRangeSelected({from, to}) {
      this.from = from;
      this.to = to;
    },
    cancel() {
      this.$emit('dismiss');
    },
    async save() {
      this.saving = true;
      this.saving = false;

      const cmd = {
        email: this.initialUser.email,
        timeModelId: this.timeModelId,
        timeModels: this.userTimeModels,
      };


      await timeparkApi.saveUserTimeModels(cmd);

      this.$refs.dateRange.clear();
      this.$emit('dismiss');
    },
    addTimeModel() {
      this.userTimeModels.push({
        start: moment.utc(this.from).format(),
        end: moment.utc(this.to).format(),
        timeModelId: this.newTimeModelId
      });

      this.$refs.dateRange.clear();
      this.newTimeModelId = null;
    },
    removeTimeModel(index) {
      this.userTimeModels.splice(index, 1);
    },
  },
  data() {
    return {
      name: this.initialUser ? this.initialUser.name : '',
      userTimeModels: this.initialUser ? [...this.initialUser.timeModels] : [],
      from: null,
      to: null,
      newTimeModelId: null,
      timeModelId: this.initialUser ? this.initialUser.timeModelId : null,
      saving: false,
    };
  },
};
</script>
